import "./style.scss";

let alertMsg = document.querySelector("#alert-msg");
let name = document.querySelector("#name");
let email = document.querySelector("#email");
let message = document.querySelector("#message");
let submitBtn = document.querySelector("#submit");

const url =
  "https://docs.google.com/forms/d/e/1FAIpQLSfQBKP8MEEeVVjXn_i0S6cOwfjnu2_eZvX1zT2O99-rRcI54w/formResponse?";

("https://docs.google.com/forms/d/e/1FAIpQLSfQBKP8MEEeVVjXn_i0S6cOwfjnu2_eZvX1zT2O99-rRcI54w/viewform?usp=pp_url&entry.1516566270=MYNAME&entry.657951292=MYEMAIL&entry.1186554715=MYMESSAGE");

// check whether or not an name is a valid value
const isValidText = (str) => str.length > 0;

function checkName() {
  if (!isValidText(name.value)) {
    name.classList.remove("form-valid");
    name.classList.add("form-error");
    name.placeholder = "please insert a valid name";
    setTimeout(function () {
      name.classList.remove("form-error");
      name.classList.remove("form-valid");
      name.placeholder = "your name*";
    }, 2000);
  } else {
    name.classList.remove("form-error");
    name.classList.add("form-valid");
  }
}

name.addEventListener("focusout", checkName);

// check whether or not an email address is correct
const isValidMail = (email) =>
  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);

function checkMail() {
  if (!isValidMail(email.value)) {
    email.classList.remove("form-valid");
    email.classList.add("form-error");
    email.placeholder = "please insert a valid e-mail address";
    setTimeout(function () {
      email.classList.remove("form-error");
      email.classList.remove("form-valid");
      email.placeholder = "your e-mail*";
    }, 2000);
  } else {
    email.classList.remove("form-error");
    email.classList.add("form-valid");
  }
}

email.addEventListener("focusout", checkMail);

// check whether or not an textfield is a valid value
function checkMessage() {
  if (!isValidText(message.value)) {
    message.classList.remove("form-valid");
    message.classList.add("form-error");
    message.placeholder = "please insert a valid message";
    setTimeout(function () {
      message.classList.remove("form-error");
      message.classList.remove("form-valid");
      message.placeholder = "your message*";
    }, 2000);
  } else {
    message.classList.remove("form-error");
    message.classList.add("form-valid");
  }
}

message.addEventListener("focusout", checkMessage);

//clear form once finished
function clearForm() {
  name.value = "";
  name.classList.remove("form-error");
  name.classList.remove("form-valid");
  email.value = "";
  email.classList.remove("form-error");
  email.classList.remove("form-valid");
  message.value = "";
  message.classList.remove("form-error");
  message.classList.remove("form-valid");
}

//return true if everything is a valid value
function isValidValues() {
  return (
    isValidText(name.value) &&
    isValidText(message.value) &&
    isValidText(message.value)
  );
}

submitBtn.addEventListener("click", function (event) {
  event.preventDefault();
  if (isValidValues()) {
    sendData();
    clearForm();
  } else {
    showAlert("Entries are not valid or incomplete", false);
  }
});

function createFullLink() {
  let NAME = name.value.trim().replaceAll(" ", "+");
  let EMAIL = email.value.toLowerCase().trim().replaceAll(" ", "+");
  let MESSAGE = message.value.trim().replaceAll(" ", "+");

  return `${url}&entry.1516566270=${NAME}&entry.657951292=${EMAIL}&entry.1186554715=${MESSAGE}&submit=SUBMIT`;
}

function sendData() {
  const header = {
    method: "POST",
    mode: "no-cors",
    redirect: "follow",
    referrer: "no-referrer",
  };

  return fetch(createFullLink(), header)
    .then(showAlert("Thank you! Your message was successfully sent.", true))
    .catch((e) => {
      console.error(e);
      showAlert("Sorry! Something went wrong:\n" + e, false);
    });
}

function showAlert(text, isSuccessful) {
  alertMsg.innerText = text;
  if (isSuccessful) {
    alertMsg.classList.remove("alert-error");
    alertMsg.classList.add("alert-success");
  } else {
    alertMsg.classList.add("alert-error");
    alertMsg.classList.remove("alert-success");
  }
  alertMsg.style.display = "block";
  setTimeout(function () {
    alertMsg.innerText = "";
    alertMsg.classList.remove("alert-success");
    alertMsg.classList.remove("alert-error");
    alertMsg.style.display = "none";
  }, 3000);
}
